<template>
  <help-dialog title="Read Models">
    <template #default>
      <h3 class="mb-1 text-black">
        <span class="bg-grey-lighten-3">Read Models</span>
      </h3>
      <p class="text-grey-darken-3">
        A <b>Read Model</b> (or Query) defines the data that is retrieved and presented to users.
        It represents a specific view or projection of your domain data.
        <br /><br />
        <b>Read Models</b> can be linked to an <b>Entity</b> to indicate which data source they read from.
        They can also have their own fields that define what data the query returns.
        <br /><br />
        <b>Read Models</b> are reusable across multiple domain events. The same Read Model
        can be referenced from different events in your workflow.
      </p>
      <br />
      <p class="text-grey-darken-3">
        A <b>Read Model</b> contains a set of data fields. The following actions are available for each field:
      </p>
      <ul class="ml-5">
        <li><b>Rename:</b>&nbsp;Change the display name of the field.</li>
        <li><b>Filter:</b>&nbsp;Mark a field as a filter parameter for the query.</li>
        <li><b>Select Entity:</b>&nbsp;Link a field to a related Entity to indicate an entity reference.</li>
        <li><b>Cardinality:</b>&nbsp;Set the relationship as 1:1 or 1:N for entity reference fields.</li>
        <li><b>Delete:</b>&nbsp;Removes the field from the list.</li>
      </ul>
    </template>
  </help-dialog>
</template>

<script>
import HelpDialog from '@/components/HelpDialog.vue'

export default {
  components: {
    HelpDialog
  }
}
</script>
